import {ObjectDTO} from "./object-dto";
import {CouleurDTO} from "./couleur-dto";

export class FamilleGemrcnDTO  extends ObjectDTO{

  libelle : string;
  code : string;
  couleur:CouleurDTO;
  actif:boolean;

  ordre:number;
}
